import { Component, OnInit, ViewChild, Input, TemplateRef } from '@angular/core';
import { AppService } from '../app.service';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css']
})
export class ErrorModalComponent implements OnInit {

  @ViewChild('content') modal: TemplateRef<any>;
  @Input('erreurs') errors: string[];

  constructor(private appService: AppService) {}

  ngOnInit() {
    this.appService.errorModal = this.modal;
  }

  fermer() {
    window.location.assign("http://sagedijon.fr");
  }

}



// WEBPACK FOOTER //
// ./src/app/error-modal/error-modal.component.ts